import React from 'react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { CatalogTable } from '../../components/page/CatalogTable';
import { SalesCallout } from '../../components/page/SalesCallout';
import { RelatedLinks } from '../../components/page/RelatedLinks';
import { catalog } from '../../data/catalog';
const contents = ['One holder in the kit’s shank size — 1-inch or 3/4-inch', '10 APGX 331R inserts (Grade MG12, .016-inch radius)', 'Torx driver', 'Extra insert screws'];
export function StarterKits() {
  usePageMeta({
    title: 'Shear Geometry Starter Kits: SG KIT 1" & 3/4" | Robertson Precision',
    description: 'Two Shear Geometry starter kits, each with a 1-inch or 3/4-inch holder, 10 APGX 331R inserts, a Torx driver and extra screws. Call 800-397-7745 to confirm fit.',
    canonical: canonicalFor('/products/starter-kits/')
  });
  return <>
      <PageHeader eyebrow="Products" title="Starter Kits" lead="Two kit configurations, one for each shank size. Each pairs a holder with a box of APGX 331R inserts, a Torx driver and extra screws — a complete starting point for one machine." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Products',
      href: '/products/'
    }, {
      label: 'Starter Kits'
    }]} data-id="element-818" data-mp="2p0nbffoxrrpe" />

      <ContentSection id="kits" title="Kit configurations" data-id="element-819" data-mp="37wddf2wvco3a">
        <CatalogTable rows={catalog.filter(c => c.category === 'kits')} caption="Shear Geometry starter kits" data-id="element-820" data-mp="32ytzk4432dbv" />
      </ContentSection>

      <ContentSection id="contents" tone="warm" title="What each kit contains" data-id="element-821" data-mp="3cpok941ol4v7">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-822" data-mp="3qp7in54ox1ub">
          <ul className="divide-y divide-rule border-y border-rule" data-id="element-823" data-mp="3qpplwlprsgbq">
            {contents.map(item => <li key={item} className="flex gap-3 py-3.5 text-[15px] text-navy" data-id="element-824" data-mp="3lrxwbycll6ap">
                <span aria-hidden="true" className="mt-2.5 h-px w-3 shrink-0 bg-copper" data-id="element-825" data-mp="2je9sxlbs2ori" />
                {item}
              </li>)}
          </ul>
          <div className="rp-measure space-y-4 text-[15.5px] leading-[1.7] text-graphite/85" data-id="element-826" data-mp="2scv7l5e4pjn0">
            <h3 className="font-display text-[19px] font-medium text-navy" data-id="element-827" data-mp="2x3ts6h65h3w2">
              Choosing a kit
            </h3>
            <p data-id="element-828" data-mp="323zowbra1gl0">
              Choose the kit by holder size: it should match the tool station on
              your machine’s turret. The catalog’s holders are SALXR 16-3D
              (1-inch shank) and SALXR 12-3B (3/4-inch shank).
            </p>
            <p data-id="element-829" data-mp="3b21tt2e4stdk">
              Have sales confirm the kit fits your machine before ordering. If
              you are unsure which size you need, the technical staff can help.
            </p>
          </div>
        </div>
        <div className="mt-10" data-id="element-830" data-mp="1loolz36t8n7p">
          <SalesCallout location="starter-kits" note="Sales confirms kit contents, fit for your machine, pricing and availability." data-id="element-831" data-mp="1lpzn0v8vfgv4" />
        </div>
      </ContentSection>

      <RelatedLinks links={[{
      label: 'Tool Holders',
      href: '/products/holders/',
      description: 'SALXR 16-3D and SALXR 12-3B holders.'
    }, {
      label: 'Inserts & Chipbreakers',
      href: '/products/inserts/',
      description: 'Replacement APGX 331R and other inserts.'
    }, {
      label: 'Accessories',
      href: '/products/accessories/',
      description: 'T-15 Torx driver and 4-15 insert screw.'
    }, {
      label: 'Tool Selection',
      href: '/technical-resources/tool-selection/',
      description: 'Match the holder shank to your turret.'
    }]} data-id="element-832" data-mp="19dxagikjohw3" />
    </>;
}